import { render } from "./TempClassManagement.vue?vue&type=template&id=41928bf2&scoped=true"
import script from "./TempClassManagement.vue?vue&type=script&lang=js"
export * from "./TempClassManagement.vue?vue&type=script&lang=js"

import "./TempClassManagement.vue?vue&type=style&index=0&id=41928bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41928bf2"]])

export default __exports__